module.exports = __webpack_public_path__ + "static/media/lutoncurtainside.a0853c28.png";